module.exports = __webpack_public_path__ + "static/media/loader-logo.2ae1f51e.svg";